interface Props {
    name: string;
    label: string;
    value: string;
    onChange: (name: string, value: string) => void;
    required: boolean;
    rows?: number;
}

export default function TextAreaField({
    name,
    label,
    value,
    required,
    onChange,
    rows = 5,
}: Props) {
    const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        event.target.classList.add('touched');
    };

    return (
        <div className='mb-3'>
            <label htmlFor={name} key={`label-${name}`} className='form-label'>
                {label}
            </label>
            <textarea
                className='form-control'
                id={name}
                key={name}
                name={name}
                value={value}
                required={required}
                onChange={(e) => onChange(name, e.target.value)}
                rows={rows}
                style={{
                    resize: 'none',
                }}
            />
        </div>
    );
}
